import { VALENCES, Valence } from "@/types/app/evaluator";
import { Tag } from "@components/library/Tag";
import React from "react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/outline";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { ContextMenu } from "@components/library/ContextMenu";

interface ValenceTagProps {
  valence: Valence;

  // If setValence is provided, a dropdown will be rendered to allow the user to change the valence.
  setValence?: (valence: Valence) => void;
  interactive?: boolean;
}

export const ValenceTag = ({ valence, setValence, interactive }: ValenceTagProps) => {
  let color: React.ComponentProps<typeof Tag>["color"];
  switch (valence) {
    case "positive":
      color = "green";
      break;
    case "negative":
      color = "red";
      break;
    case "neutral":
      color = "gray";
      break;
  }
  const tag = (
    <Tag
      size={20}
      interactive={interactive}
      color={color}
      IconRight={setValence ? ChevronDownIcon : undefined}
      className={setValence ? "cursor-pointer" : ""}
    >
      {valence}
    </Tag>
  );

  if (!setValence) {
    return tag;
  }
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>{tag}</DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <ContextMenu.Items
          isDropdownMenu
          className="w-[132px]"
          // For some reason, align="end" here aligns to the left, and align="start" aligns to the right.
          // No idea why. If this ever changes, the original intention was to align the dropdown to the left.
          align="end"
          sideOffset={4}
        >
          {VALENCES.map((v) => (
            <ContextMenu.Item
              key={v}
              withinDropdownMenu
              onClick={() => setValence(v)}
              IconRight={v === valence ? CheckIcon : undefined}
            >
              <ValenceTag valence={v} />
            </ContextMenu.Item>
          ))}
        </ContextMenu.Items>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
